var CardTextList = function () {

	this.init = function () {

	}

	return this.init();
}
